class Command {
  static typeTransform = "transform";
  static typeAdd = "add";
  static typeRemove = "remove";
  static typeReorder = "reorder";

  static typePosition = "position";
  static typeRotation = "rotation";
  static typeScale = "scale";

  static typeMaterialColor = "materialColor";
  static typeLightColor = "lightColor";
  static typeLightIntensity = "lightIntensity";
  static typeLightDistance = "lightDistance";
  static typeHemisphereLightColor = "hemisphereLightColor";
  static typeHemisphereLightGroundColor = "hemisphereLightGroundColor";
  static typeSpotLightTargetX = "spotLightTargetX";
  static typeSpotLightTargetY = "spotLightTargetY";
  static typeBlending = "blending";
  static typeOpacity = "opacity";
  static typeEmissiveIntensity = "emissiveIntensity";
  static typeEmissive = "emissive";
  static typeMaterialOffsetX = "materialOffsetX";
  static typeMaterialOffsetY = "materialOffsetY";
  static typeMaterialRepeatX = "materialRepeatX";
  static typeMaterialRepeatY = "materialRepeatY";
  static typeMaterialRotation = "materialRotation";
  static typeShininess = "shininess";
  static typeMap = "map";
  static typeNormalMap = "normalMap";
  static typeEnvMap = "envMap";
  static typeSpriteTransform = "spriteTransform";
  static typeMultiselectAdd = "multiselectAdd";
  static typeMultiselectRemove = "multiselectRemove";

  constructor(obj) {
    this.type = obj.type;
    this.subType = obj.subType;
    this.target = obj.target;
    this.preValue = obj.preValue;
    this.postValue = obj.postValue;
    this.preUserData = obj.preUserData;
    this.postUserData = obj.postUserData;

    this.parent = obj.parent;
    if (this.parent) this.index = this.parent.children.indexOf(this.target);
  }
}

export default Command;
